import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";
import { resolveUrl } from "@/lib/apiClient";

export default function SiteHeader({ settings, header }) {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = header?.nav || [];
  return (
    <header data-testid="site-header" className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/80 border-b border-[#2C3531]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between gap-4">
        <Link to="/" data-testid="site-logo" className="flex items-center gap-2 shrink-0">
          {settings?.logo_url ? (
            <img src={resolveUrl(settings.logo_url)} alt={settings?.site_name} className="h-9 w-auto object-contain" />
          ) : (
            <>
              <Sparkles className="w-5 h-5" style={{ color: settings?.brand_accent || "#9A8C73" }} strokeWidth={1.75} />
              <span className="font-display text-2xl font-semibold tracking-tight text-[#2C3531]">{settings?.site_name || "Grow Your Bookings"}</span>
            </>
          )}
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((n) => (
            <Link key={n.href} to={n.href} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm font-medium transition-colors hover:text-[#2C3531] ${loc.pathname === n.href ? "text-[#2C3531]" : "text-[#4A5550]"}`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to={header?.cta_login_href || "/salon/login"} data-testid="header-login-btn"
            className="text-sm font-semibold text-[#2C3531] px-4 py-2 rounded-full border border-[#2C3531]/20 hover:bg-[#F3EFE7] transition-colors">
            {header?.cta_login_label || "Salon Login"}
          </Link>
          <Link to={header?.cta_primary_href || "/register"} data-testid="header-cta-btn"
            className="text-sm font-semibold text-[#FDFBF7] px-5 py-2.5 rounded-full bg-[#2C3531] hover:scale-105 transition-transform duration-300">
            {header?.cta_primary_label || "Start Free Trial"}
          </Link>
        </div>

        <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} className="lg:hidden p-2 text-[#2C3531]">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#2C3531]/10 bg-[#FDFBF7] px-6 py-5 space-y-4" data-testid="mobile-menu">
          {nav.map((n) => (
            <Link key={n.href} to={n.href} onClick={() => setOpen(false)} className="block text-base font-medium text-[#2C3531]">{n.label}</Link>
          ))}
          <div className="flex flex-col gap-3 pt-3">
            <Link to={header?.cta_login_href || "/salon/login"} onClick={() => setOpen(false)} className="text-center text-sm font-semibold text-[#2C3531] px-4 py-2.5 rounded-full border border-[#2C3531]/20">{header?.cta_login_label || "Salon Login"}</Link>
            <Link to={header?.cta_primary_href || "/register"} onClick={() => setOpen(false)} className="text-center text-sm font-semibold text-[#FDFBF7] px-4 py-2.5 rounded-full bg-[#2C3531]">{header?.cta_primary_label || "Start Free Trial"}</Link>
          </div>
        </div>
      )}
    </header>
  );
}
